<div class="cart-wrapper comman-wrap">
  <ng-container>
    <app-header></app-header>
  </ng-container>
  <ng-container>
    <app-breadcrumb-nav [breadCrumbData]="breadCrumbData" [menuData]="menuListData" [storeDetails]="storeDetails">
    </app-breadcrumb-nav>
  </ng-container>
  <div *ngIf="!noItem; else noproduct">
  <!--mobile view header-->
  <div class="d-block" *ngIf="isMobile">
    <div class="mobile-navbar  white-header">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-4">
            <div class="left" (click)="gotoPrevious()" matRipple [matRippleColor]="ripColor">
              <img src="assets/icon/arrow_left.svg" alt="back">
            </div>
          </div>
          <div class="col-4 text-center">
            <div class="title animate__animated animate__fadeIn">
              <p>Your Cart</p>
            </div>
          </div>
          <div class="col-4 text-right">
            <p [routerLink]="['/ordering']">New Order</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!---header end-->
  <div class="cart-details">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="text">
            <!-- <h4 class="animate__animated animate__fadeIn">INSTANT DELIVERY</h4> -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="coupon-strip-desktop d-flex" *ngIf="invoiceLevelCoupon.length != 0">
            <p>‘{{invoiceLevelCoupon[0]['promotionName']}}’ Applied</p>
          </div>
          <ng-container *ngIf="isMobile">
            <div class="coupon-strip-mobile d-flex" *ngIf="invoiceLevelCoupon.length != 0">
              <p *ngIf="invoiceLevelCoupon.length != 0">‘{{invoiceLevelCoupon[0]['promotionName']}}’ Applied</p>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="!showCartShimmer">
        <div class="cart-item-list" *ngFor="let item of cartData?.items;let index=index">
          <div class="row">
            <div class="col-3 col-md-1 image">
              <div class="product-image"
                [ngClass]="{'inStock': !item.inStock,'inStock-Modifier': item.modifter === false}">
                <img src="{{item.image}}" (error)="item.image = 'assets/icon/placeholder.svg'" alt="product-icon" style=" width: 80px;
                                height: 80px;
                                border-radius: 8px;
                                object-fit: cover;">
              </div>
            </div>
            <div class="col-4 col-md-4 description">
              <div class="product-name underline">
                <div class="veg">
                  <div *ngFor= "let param of item.parameters">
                    <span *ngIf=" param.name === 'VEG' && param.value === 'Yes' ">
                      <img src="assets/icon/veg.svg" alt="veg-item" />
                    </span>
                    <span *ngIf=" param.name === 'VEG' && param.value === 'No'">
                      <img src="assets/icon/nonveg.svg" alt="non-veg" />
                    </span>
                  </div>
                </div>
                <h5>{{item.name}}</h5>
                <p *ngIf="!isMobile">
                  <span class="product-customization-list">{{content[index]}}</span>
                  <span *ngIf="!isContentToggled[index] && itemCustomizationArr[index]?.length>50">.. </span>
                  <span class="view-more" *ngIf="!isContentToggled[index] && itemCustomizationArr[index]?.length>50"
                    (click)="toggleContent(index,50)"><u>View More </u></span>
                  <span class="view-more" *ngIf="isContentToggled[index] && itemCustomizationArr[index]?.length>50"
                    (click)="toggleContent(index,50)"><u> View Less </u></span>
                </p>
                <p *ngIf="isMobile">
                  <span class="product-customization-list">{{content[index]}}</span>
                  <span *ngIf="!isContentToggled[index] && itemCustomizationArr[index].length>60">.. </span>
                  <span class="view-more" *ngIf="!isContentToggled[index] && itemCustomizationArr[index].length>60"
                    (click)="toggleContent(index,60)"><u>View More </u></span>
                  <span class="view-more" *ngIf="isContentToggled[index] && itemCustomizationArr[index].length>60"
                    (click)="toggleContent(index,60)"><u> View Less </u></span>
                </p>
                <ng-container *ngFor="let couponDetail of item.couponNew">
                  <h4 *ngIf="couponDetail?.conditionLevel != 'invoice'">
                    <span class="applied" *ngIf="couponDetail?.promotionName">
                      <img src="assets/icon/Group 346@2x.png" alt="offer-applied"
                        class="offers">{{couponDetail?.promotionName | textLimit: 18}}
                    </span>
                  </h4>
                  <h4>
                  </h4>
                </ng-container>
              </div>
            </div>
            <div class=" col-2 col-md-2 d-none d-sm-block no-data">
            </div>
            <div class="col-2 col-md-3 text-right inc-dec-btn align-self-center" *ngIf="!isMobile">
              <div class="quantity" [ngClass]="{'shimmer-loader-button': showDecrementShimmer && removedItemIndex === index}">
                <div class="wrap" [ngClass]="{'br animate-decrement-btn' : showDecrementShimmer && removedItemIndex === index}">
                  <a class="quantity__minus"
                    [ngStyle]="{'display': showDecrementShimmer && removedItemIndex === index ? 'none' : 'block'}"
                    (click)="decrement(item,index)"><span [ngClass]="{'poos':!item.inStock || !item.modifter}">-</span></a>
                  <span class="val">{{item.quantity}}</span>
                  <a class="quantity__plus" [ngStyle]="{'display': showDecrementShimmer && removedItemIndex === index ? 'none' : 'block'}"
                   (click)="increment1(item)"><span [ngClass]="{'poos':!item.inStock || !item.modifter}">+</span></a>
                </div>
              </div>
              <div class="increment-btn">
              </div>
            </div>
            <div class="col-3 col-md-2 text-right price align-self-center">
              <div class="price underline">
                <p>₹ {{item.price}}</p>
                <div class="inc-dec-btn" *ngIf="isMobile">
                  <div class="quantity" [ngClass]="{'shimmer-loader-button': showDecrementShimmer && removedItemIndex === index}">
                    <div class="wrap" [ngClass]="{'br animate-decrement-btn' : showDecrementShimmer && removedItemIndex === index}">
                      <a class="quantity__minus"
                        [ngStyle]="{'display': showDecrementShimmer && removedItemIndex === index ? 'none' : 'block'}"
                        (click)="decrement(item,index)"><span [ngClass]="{'poos':!item.inStock || !item.modifter}">-</span></a>
                      <span class="val">{{item.quantity}}</span>
                      <a class="quantity__plus" [ngStyle]="{'display': showDecrementShimmer && removedItemIndex === index ? 'none' : 'block'}"
                       (click)="increment1(item)"><span [ngClass]="{'poos':!item.inStock || !item.modifter}">+</span></a>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="isCustomised">
                  <h6 class="customized" *ngIf="item.inStock && item.modifter && item.options"
                    (click)="customized(item,item.price);customiseViewCartGA()">
                    Customise
                  </h6>
                  <h6 class="customized" *ngIf="item.inStock && !item.modifter && item.options"
                    (click)="customized(item,item.price);customiseViewCartGA()">
                    Customise
                  </h6>
                  <h6 class="customized" *ngIf="!item.inStock && !item.modifter && item.options"
                    (click)="decrement(item,index)">
                    Remove
                  </h6>
                  <h6 class="customized" *ngIf="!item.inStock && item.modifter && !item.options"
                  (click)="decrement(item,index)">
                  Remove
                </h6>
                  <h6 class="customized" *ngIf="!item.inStock && item.modifter && item.options"
                    (click)="decrement(item,index)">
                    Remove
                  </h6>
                </ng-container>
              </div>
            </div>
            <div class="col-12 mb-2 mt-2" *ngIf="!item.inStock">
              <div class="oos">
                <div class="box">
                  <img src="assets/icon/oos.svg">
                </div>
                <div class="box">
                  <h5> This item is out of Stock</h5>
                  <p>Please select another item</p>
                </div>
              </div>
            </div>
            <ng-container *ngIf="item.inStock">
              <div class="col-12  mb-2 mt-2" *ngIf="item.modifter === false">
                <div class="oos">
                  <div class="box">
                    <img src="assets/icon/oos.svg">
                  </div>
                  <div class="box">
                    <h5>Item unavailable!</h5>
                    <p>{{item.modifterName}} {{item.modifterName.length>1 ? 'are':'is'}} out of stock.Please choose another customisation to continue.</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12">
          <p class="add-more" (click)="addMore()">+ Add More Items</p>
        </div>
      </ng-container>
      <ng-container *ngIf="showCartShimmer">
        <div class="shimmer-border-btm" *ngFor="let data of  [0,1]">
          <div class="shimmer-wrap">
            <div class="wrapper">
              <div class="py-2 px-4 d-flex justify-content-between align-items-center">
                <div class="cardPic animate din"></div>
                <div class="w-60">
                  <p class="comment-second br animate w-20"></p>
                  <p class="comment-second br animate" [ngClass]="{'w-60':isMobile,'w-40':!isMobile}"></p>
                </div>
                <div class="w-20" *ngIf="!isMobile">
                  <p class="shimmer-button br animate w-40"></p>
                </div>
                <div class="w-20">
                  <p class="shimmer-button br animate w-40 show-right" [ngClass]="{'w-75':isMobile}"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="allOffers">
    <div class="apply-offers-strip " (click)="applyReward();applyOfferGA()">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-between" [ngClass]="{'shimmer-loader-button': showOfferShimmer}">
            <h6 class="apply-offers-text animate__animated animate__fadeIn">
              <img src="assets/icon/Gift.svg" alt="offer" class="offers">
              Rewards and Offers
            </h6>
            <p class="offers-count " [ngClass]="{'br animate-offers-strip' : showOfferShimmer}">
              {{couponCountDisplay ? couponCountDisplay : 0}} offers
              <img src="assets/icon/right-arrow.png" alt="arrow-icon" *ngIf="couponCountDisplay" class="arrow">
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!allOffers">
    <div class="apply-offers-strip" (click)="applyReward();applyOfferGA()">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-between">
            <h6 class="apply-offers-text">
              <img src="assets/icon/Gift.svg" alt="offer" class="offers">
              Rewards and Offers
            </h6>
            <p>
              0 offers
              <img src="assets/icon/right-arrow.png" alt="arrow-icon" class="arrow">
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--cross sell up sell start-->
  <div class="cross-sell-section light-yellow-panel" *ngIf="sliderData && sliderData.length != 0"
    style="padding-bottom: 6em;">
    <ng-container *ngIf="sliderData && sliderData.length > 2;else noSlide_Content">
      <span class="right-leaf">
        <img src="assets/icon/greyleafright.svg" alt="green-tier">
      </span>
      <span class="left-leaf2">
        <img src="assets/icon/Group3.svg" alt="green-tier">
      </span>
      <div class="container">
        <div class="row">
          <div class="col-md-6  col-sm-12">
            <h2 class="label animate__animated animate__fadeIn">Popular Choice </h2>
          </div>
          <div class="col swiper-col">
            <swiper [config]="config" #usefulSwiper [spaceBetween]="50" [autoHeight]="true"
              (swiper)="setControlledSwiper($event)" [navigation]="{}" [pagination]="{ clickable: true }">
              <ng-template swiperSlide *ngFor="let data of sliderData">
                <div class="card animate__animated animate__fadeIn">
                  <div class="card-horizontal" style="margin-bottom: 0px;">
                    <div class="img-square-wrapper" [ngClass]="{'inStock': !data.inStock}">
                      <img src="{{data?.images?.small[0]['url']}}"
                        (error)="data.images.small[0]['url'] = 'assets/icon/placeholder.svg'"
                        (click)="expandImage(data)" alt="">
                    </div>
                    <div class="card-body">
                      <div class="newitem">
                        <div class="veg-newlaunch">
                          <div class="veg" *ngFor="let param of data.parameters">
                            <span *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                              <img src="assets/icon/veg.svg" alt="veg-item">
                            </span>
                            <span *ngIf="param.name === 'VEG' && param.value === 'No'">
                              <img src="assets/icon/nonveg.svg" alt="non-veg">
                            </span>
                          </div>
                          <div class="newlaunch" *ngFor="let param of data.parameters">
                            <h6>
                              <span class="badge badge-secondary"
                                *ngIf="param.name == 'IsNewLaunch' && param.value == 'Yes'">
                                New Launch
                              </span>
                            </h6>
                          </div>
                        </div>
                      </div>
                      <h3 class="card-title">{{data.name}}</h3>
                      <!--diet info-->
                      <ng-container *ngIf="data.options && data.options['customization']">
                        <div class="diet"
                          *ngFor="let diet of data.options['customization']['modifiersItems'] ; let i = index">
                          <h5 class="diet-options">
                            <ng-container *ngIf="diet.name === 'Size'">
                              <span *ngFor="let item of diet['items'];let j = index;">
                                <span *ngIf="diet['defaultItemIds'][0] === item.id">{{item.name}}({{item.description}})
                                  . {{item.dietaryInformation}}</span>
                              </span>
                            </ng-container>
                          </h5>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="card-footer-custom">
                    <div class="left-item">
                      <h4>₹ {{data.defaultPrice | number : '1.0-0'}}<span class="round-figure">.00</span></h4>
                    </div>
                    <div class="left-item">
                      <button type="button" [disabled]="!data.inStock" (click)="addItem(data)"
                        class="custom-btn btn-green btn-sm-rounded">
                        {{!data.inStock ? 'Out of Stock':'Add Item'}}
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </swiper>
          </div>
        </div>
        <div class="col-12 text-center  mt-4 d-block d-sm-none view-menu-btn">
          <button type="button" class="custom-btn btn-md-rounded btn-black" [routerLink]="['/ordering']">View our
            menu</button>
        </div>
      </div>
    </ng-container>
    <ng-template #noSlide_Content>
      <ng-container *ngIf="!isMobile">
        <span class="right-leaf">
          <img src="assets/icon/greyleafright.svg" alt="green-tier">
        </span>
        <span class="left-leaf2">
          <img src="assets/icon/Group3.svg" alt="green-tier">
        </span>
        <div class="container">
          <div class="row">
            <div class="col-md-12  col-sm-12">
              <h2>Popular Choice </h2>
            </div>
            <div class="col-12 col-md-4 mb-4" *ngFor="let data of sliderData">
              <div class="card">
                <div class="card-horizontal" style="margin-bottom: 0px;">
                  <div class="img-square-wrapper" [ngClass]="{'inStock': !data.inStock}">
                    <img src="{{data?.images?.small[0]['url']}}"
                      (error)="data?.images?.small[0]['url'] = 'assets/icon/placeholder.svg'"
                      (click)="expandImage(data)" alt="">
                  </div>
                  <div class="card-body">
                    <div class="newitem">
                      <div class="veg-newlaunch">
                        <div class="veg" *ngFor="let param of data.parameters">
                          <span *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                            <img src="assets/icon/veg.svg" alt="veg-item">
                          </span>
                          <span *ngIf="param.name === 'VEG' && param.value === 'No'">
                            <img src="assets/icon/nonveg.svg" alt="non-veg">
                          </span>
                        </div>
                        <div class="newlaunch" *ngFor="let param of data.parameters">
                          <h6>
                            <span class="badge badge-secondary"
                              *ngIf="param.name == 'IsNewLaunch' && param.value == 'Yes'">
                              New Launch
                            </span>
                          </h6>
                        </div>
                      </div>
                    </div>
                    <h3 class="card-title">{{data.name}}</h3>
                    <!--diet info-->
                    <ng-container *ngIf="data.options && data.options['customization']">
                      <div class="diet"
                        *ngFor="let diet of data.options['customization']['modifiersItems'] ; let i = index">
                        <h5>
                          <ng-container *ngIf="diet.name === 'Size'">
                            <span *ngFor="let item of diet['items'];let j = index;">
                              <span *ngIf="diet['defaultItemIds'][0] === item.id">{{item.name}}({{item.description}}) .
                                {{item.dietaryInformation}}</span>
                            </span>
                          </ng-container>
                        </h5>
                      </div>
                    </ng-container>
                    <p class="b-s" *ngFor="let param of data.parameters" style="margin-bottom: 0px;">
                      <span *ngIf="param.name == 'ISBESTSELLER' && param.value == 'Yes'">
                        <img src="assets/icon/Solid Large.svg" style="width: 12px;height:12px;margin-top: -2px;">
                        Bestseller
                      </span>
                    </p>
                  </div>
                </div>
                <div class="card-footer-custom">
                  <div class="left-item">
                    <h4>₹ {{data.defaultPrice | number : '1.0-0'}}<span class="round-figure">.00</span></h4>
                  </div>
                  <div class="left-item">
                    <button type="button" [disabled]="!data.inStock" (click)="addItem(data)"
                      class="custom-btn btn-green btn-sm-rounded">
                      {{!data.inStock ? 'Out of Stock':'Add Item'}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center  mt-4 d-block d-sm-none view-menu-btn">
              <button type="button" class="custom-btn btn-md-rounded btn-black" [routerLink]="['/ordering']">View our
                menu</button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isMobile">
        <div class="container">
          <div class="row">
            <div class="col-12 mb-4">
              <h2 class="label animate__animated animate__fadeIn">Popular Choice </h2>
              <swiper [config]="config" #usefulSwiper [spaceBetween]="50" [autoHeight]="true"
                (swiper)="setControlledSwiper($event)" [navigation]="{}" [pagination]="{ clickable: true }">
                <ng-template swiperSlide *ngFor="let data of sliderData">
                  <div class="card animate__animated animate__fadeIn">
                    <div class="card-horizontal" style="margin-bottom: 0px;">
                      <div class="img-square-wrapper" [ngClass]="{'inStock': !data.inStock}">
                        <img src="{{data?.images?.small[0]['url']}}"
                          (error)="data.images.small[0]['url'] = 'assets/icon/placeholder.svg'"
                          (click)="expandImage(data)" alt="">
                      </div>
                      <div class="card-body">
                        <div class="newitem">
                          <div class="veg-newlaunch">
                            <div class="veg" *ngFor="let param of data.parameters">
                              <span *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                                <img src="assets/icon/veg.svg" alt="veg-item">
                              </span>
                              <span *ngIf="param.name === 'VEG' && param.value === 'No'">
                                <img src="assets/icon/nonveg.svg" alt="non-veg">
                              </span>
                            </div>
                            <div class="newlaunch" *ngFor="let param of data.parameters">
                              <h6>
                                <span class="badge badge-secondary"
                                  *ngIf="param.name == 'IsNewLaunch' && param.value == 'Yes'">
                                  New Launch
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                        <h3 class="card-title">{{data.name}}</h3>
                        <!--diet info-->
                        <ng-container *ngIf="data.options && data.options['customization']">
                          <div class="diet"
                            *ngFor="let diet of data.options['customization']['modifiersItems'] ; let i = index">
                            <h5 class="diet-options">
                              <ng-container *ngIf="diet.name === 'Size'">
                                <span *ngFor="let item of diet['items'];let j = index;">
                                  <span
                                    *ngIf="diet['defaultItemIds'][0] === item.id">{{item.name}}({{item.description}})
                                    . {{item.dietaryInformation}}</span>
                                </span>
                              </ng-container>
                            </h5>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="card-footer-custom">
                      <div class="left-item">
                        <h4>₹ {{data.defaultPrice | number : '1.0-0'}}<span class="round-figure">.00</span></h4>
                      </div>
                      <div class="left-item">
                        <button type="button" [disabled]="!data.inStock" (click)="addItem(data)"
                          class="custom-btn btn-green btn-sm-rounded">
                          {{!data.inStock ? 'Out of Stock':'Add Item'}}
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </swiper>
            </div>
            <div class="col-12 text-center   d-block d-sm-none">
              <button type="button" class="custom-btn btn-md-rounded btn-black" [routerLink]="['/ordering']">View our
                menu</button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>
  <!--cross sell up sell end-->
  <form [formGroup]="viewCartFormGroup" class="other-request-form">
    <div class="type-mssg">
      <div class="container">
        <div class="row">
          <div class="col-12 heading">
            <p class="other-request-form mt-1em"><img src="assets/icon/list.svg" alt="mssg" />ANY OTHER REQUEST?</p>
          </div>
          <div class="col-12 txt-area">
            <div class="text-area">
              <mat-form-field floatLabel="never">
                <textarea matInput name="questionText" cols="35" rows="8"
                  placeholder="Have something specific in mind? Write it down and we’ll let our baristas know."
                  formControlName="textmssg" maxlength="500"></textarea>
                <mat-error *ngIf="viewCartFormGroup.controls['textmssg'].hasError('pattern')">
                  Please enter alphabets and numbers only
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="customer-details mt-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h6 class="label">
              CUSTOMER DETAILS
            </h6>
          </div>
        </div>
      </div>
      <hr>
      <div class="container radio-btn-section">
        <div class="row input-fields">
          <div class="col-md-6">
              <label class="label_text">FIRST NAME</label>
              <mat-form-field class="example-full-width" floatLabel="never">
                  <input placeholder="Enter Name" matInput required formControlName="fname" 
                      maxlength="50">
                  <mat-error *ngIf="viewCartFormGroup.controls['fname'].hasError('required')">
                      First Name is required
                  </mat-error>
                  <mat-error *ngIf="viewCartFormGroup.controls['fname'].hasError('pattern')">
                      Please enter alphabets only
                  </mat-error>
              </mat-form-field>
              <p class="success-text" *ngIf="updatedFname">Your first name was updated</p>
          </div>
          <div class="col-md-6">
            <label class="label_text">MOBILE NUMBER</label>
            <mat-form-field class="example-full-width" floatLabel="never">
                <input type="tel" placeholder="Enter Mobile Number" maxlength="10" matInput required [OnlyNumber]="true"
                    formControlName="mobileNumber" #mobnum>
                <mat-error *ngIf="viewCartFormGroup.controls['mobileNumber'].hasError('required')">
                    Mobile Number is required
                </mat-error>
                <mat-error *ngIf="viewCartFormGroup.controls['mobileNumber'].hasError('pattern')">
                    Please enter a valid Mobile Number.
                </mat-error>
                <mat-error *ngIf="viewCartFormGroup.controls['mobileNumber'].hasError('minlength')">
                    Please enter a valid Mobile Number.
                </mat-error>
            </mat-form-field>
            <p class="success-text" *ngIf="updatedPhNo">Your mobile number was updated</p>
        </div>
        <div class="col-md-6">
          <label class="label_text">EMAIL ID (optional)</label>
          <mat-form-field class="example-full-width" floatLabel="never">
              <input placeholder="Enter Email Id" matInput  formControlName="emailId" #email
                  maxlength="320">
                  <mat-error *ngIf="viewCartFormGroup.controls['emailId'].hasError('pattern')">
                    Please enter a valid Email ID.
                </mat-error>
          </mat-form-field>
          <p *ngIf="updatedEmailId" class="success-text">Your email id was updated</p>
      </div>
          </div>
      </div>
    </div>
    <div class="pickup-details">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h6 class="label">
              PICK UP DETAILS
            </h6>
          </div>
        </div>
      </div>
      <hr>
      <div class="container radio-btn-section">
        <div class="row">
          <div class="col-12 mb-3">
            <div class="form-group mb-1em">
               <mat-radio-group aria-label="Select an option" formControlName="pickuptypes">
                <mat-radio-button value="takeaway" [checked]="defaultChecked">Take-away</mat-radio-button>
                <mat-radio-button value="dine-in">Dine-in</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="bill-details">
    <div class="price-breakup">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h6 class="label">BILL DETAIL</h6>
          </div>
          <div class="col-6">
            <p>Sub Total</p>
            <p *ngIf="cartData?.coupons.length === 0">Discount</p>
            <p (click)="toggleDropdown()" *ngIf="cartData?.coupons.length != 0">Discount
              <img *ngIf="!showDiscountBar" src="assets/icon/arrow_down_green.svg" alt="dropdown-icon">
              <img *ngIf="showDiscountBar" src="assets/icon/arrow_up_green.svg" alt="dropdown-icon">
            </p>
            <div *ngIf="showDiscountBar">
              <p class="text-green" *ngFor="let cpn of cartData?.coupons">'{{cpn.promotionName}}' Applied</p>
            </div>
            <p>Taxes</p>
          </div>
          <div class="col-6 text-right price-values">
            <p>₹ {{cartData?.subTotal.value | number : '1.2-2'}}</p>
            <p class="text-green">- ₹ {{cartData?.discountAmount.value | number : '1.2-2'}}</p>
            <div *ngIf="showDiscountBar">
              <p class="text-green" *ngFor="let cpn of cartData?.coupons">- ₹{{cpn.discountAmount | number : '1.2-2'}}
              </p>
            </div>
            <p>₹ {{cartData?.tax.value | number : '1.2-2'}}</p>
          </div>
        </div>
        <hr>
        <div class="row grand-total">
          <div class="col-6">
            <h5> TOTAL</h5>
          </div>
          <div class="col-6 text-right">
            <p>₹ {{cartData?.total.value | number : '1.2-2'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="order-alert">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p><img src="assets/icon/info.svg" alt="info"><span class="ps-2">(Order once placed cannot be
              cancelled)</span></p>
        </div>
      </div>
    </div>
  </div>
  <div class="price-details fixed-bottom-footer2 animate__animated animate__fadeIn">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-8">
          <div class="item-and-price">
            <div *ngIf="cartData && !isMobile">
              <h5>{{cartData.items.length}} ITEM ADDED</h5>
              <p *ngIf="cartData.items.length === 1">{{cartData['items'][0]['name']}}</p>
              <p *ngIf="cartData.items.length != 1">{{cartData['items'][0]['name']}}...+ {{cartData.items.length-1}}
                more</p>
            </div>
            <div *ngIf="cartData && isMobile">
              <h5>{{cartData.items.length}} ITEM ADDED</h5>
              <p *ngIf="cartData.items.length === 1">{{cartData['items'][0]['name'] | textLimit: 28}}</p>
              <p *ngIf="cartData.items.length != 1">{{cartData['items'][0]['name'] | slice:0:10}}...+
                {{cartData.items.length-1}} more</p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="item-and-price" style="justify-content: flex-end;">
            <div>
              <h4>₹ {{cartData?.total.value | priceformat:'integer' }}<span class="round-figure">.{{cartData?.total.value |
                  priceformat:'decimal'}}</span></h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="add-to-cart fixed-bottom-footer">
    <div class="container">
      <div class="row">
        <div class="col-7" *ngIf="verifyLoggedInUser">
          <div class="pay-with payment-mode">
            <div *ngIf="paymentDetails.length != 0 && paymentDetails != null">
              <h5>Pay with </h5>
              <p *ngIf="!isMobile" class="pointer" (click)="openPaymentMode()">
                {{(paymentDetails[0].paymentMode == 'CASH' ? 'CASH' : (paymentDetails[0].paymentMode == 'MANUAL_EDC' ? 'MANUAL_EDC' : 'Other Payment Methods') )}}<span>
                  <img src="assets/icon/upward_chevron@2x.png" *ngIf="(paymentDetails | json) != '{}'" alt="upward"></span></p>
              <p *ngIf="isMobile" class="pointer" (click)="openPaymentMode()">
                {{(paymentDetails[0].paymentMode == 'CASH' ? 'CASH' : (paymentDetails[0].paymentMode == 'MANUAL_EDC' ? 'MANUAL_EDC' : 'Other Payment Methods'))}}<span>
                  <img src="assets/icon/upward_chevron@2x.png" *ngIf="(paymentDetails | json) != '{}'" alt="upward"></span></p>
            </div>
            <div *ngIf="paymentDetails.length == 0 ||  paymentDetails == null">
              <h5>Pay with </h5>
              <p class="pointer" [ngClass]="{'oosp':!inStockAllProduct || inStockAllModifier}" (click)="selectPayment()">Select Payment Mode<span><img
                    src="assets/icon/upward_chevron@2x.png" alt="upward"></span></p>
            </div>
          </div>
        </div>
        <div class="col-5 text-right" [ngClass]="{'col-12': !verifyLoggedInUser}">
          <button type="button" [disabled]='disablePayBtn || !inStockAllProduct || inStockAllModifier || viewCartFormGroup.invalid'
            class="add-cart-btn place-order-btn" [class.disable-btn-style]='disablePayBtn' *ngIf="verifyLoggedInUser"
            (click)="placeOrder(viewCartFormGroup.value);userPlaceOrderClickGA()">Place Order</button>
          <button type="button" [disabled]='!inStockAllProduct || inStockAllModifier'
            class="add-cart-btn place-order-btn full-width-btn" *ngIf="!verifyLoggedInUser"
            (click)="openLoginDialog();guestUserPaymentClickGA()">Continue with Payment </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noproduct>
  <section class="noproduct">
    <div class="container">
      <div class="row">
         <div class="col-12 mt-2 text-center" style="margin-top: 7em !important;">
          <img src="assets/icon/NoCartfound.svg" alt="no cart" rel="preload">
          <h6 class="mt-4"><b>No items found!</b></h6>
         <p>Please add items to see here</p>
         <button type="button" class="custom-btn btn-green btn-sm-rounded" (click)="gotoOrder()" style="padding: 1em 7em;"> Go to Menu </button>
        </div>
      </div>
    </div>
  </section>
</ng-template>
</div>
